import React from "react";
import { Coins, RotateCcw, XCircle, Clock } from "lucide-react";
import LegalPageLayout from "../components/LegalPageLayout";

const SECTIONS = [
  { icon: Coins, title: "What you're buying", points: [
    "Ishukart sells one-time credit packs (Starter ₹199 · 50 credits, Builder ₹499 · 150 credits, Studio ₹999 · 350 credits). There are no subscriptions and no automatic renewals.",
    "Paid credits never expire.",
  ] },
  { icon: RotateCcw, title: "Automatic credit refunds", points: [
    "If an AI build fails or is interrupted, the credits used for that message are returned to your balance automatically.",
    "You can see every deduction and refund on the Billing page.",
  ] },
  { icon: XCircle, title: "Money refunds", points: [
    "Unused paid credits can be refunded to your original payment method within 7 days of purchase — contact support with your payment ID.",
    "Credits already used for successful builds are not refundable.",
    "Duplicate or failed-but-charged payments are always refunded in full.",
  ] },
  { icon: Clock, title: "Timelines", points: [
    "Approved refunds are initiated within 2 business days and usually reach your account in 5–7 business days, depending on your bank.",
  ] },
];

export default function CancellationRefund() {
  return (
    <LegalPageLayout badge="Policy" title="Cancellation & refunds" subtitle="Simple, fair rules for credit purchases on Ishukart." lastUpdated="June 2026" sections={SECTIONS}
      ctaTitle="Need a refund?" ctaText="Send us your registered email and Razorpay payment ID." />
  );
}
